export const WALLET_MIRROR_MIGRATION_SQL = `
CREATE TABLE IF NOT EXISTS wallet_authoritative_snapshot (
  singleton_id INTEGER PRIMARY KEY CHECK (singleton_id = 1),
  snapshot_json TEXT NOT NULL,
  updated_at TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS wallet_command_results (
  idempotency_key TEXT PRIMARY KEY,
  result_json TEXT NOT NULL,
  created_at TEXT NOT NULL
);
`;
//# sourceMappingURL=008_wallet_mirror.sql.js.map